"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _material = require("@mui/material");

var _reactRedux = require("react-redux");

var _ui = require("@alycecom/ui");

var _styles = require("@mui/styles");

var _CountriesPicker = require("../../../../../Shared/components/CountriesPicker");

var _commonData = require("../../../../../Shared/store/commonData/commonData.selector");

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing;
  return {
    selector: {
      minWidth: 250,
      marginLeft: spacing(1)
    },
    countryButtonWrapper: {
      width: 250
    },
    countryValueLabel: {
      overflow: 'hidden'
    },
    popper: {
      width: 320,
      minWidth: 320
    }
  };
});

var CampaignsFilter = function CampaignsFilter(_ref2) {
  var _filters$search, _filters$countryIds;

  var _ref2$filters = _ref2.filters,
      filters = _ref2$filters === void 0 ? {} : _ref2$filters,
      onUpdate = _ref2.onUpdate,
      availableCountryIds = _ref2.availableCountryIds;
  var classes = useStyles();

  var _useState = (0, _react.useState)((_filters$search = filters === null || filters === void 0 ? void 0 : filters.search) !== null && _filters$search !== void 0 ? _filters$search : ''),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      searchValue = _useState2[0],
      setSearchValue = _useState2[1];

  var _useState3 = (0, _react.useState)((_filters$countryIds = filters === null || filters === void 0 ? void 0 : filters.countryIds) !== null && _filters$countryIds !== void 0 ? _filters$countryIds : []),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      selectedCountriesIds = _useState4[0],
      setSelectedCountriesIds = _useState4[1];

  var allCountries = (0, _reactRedux.useSelector)(_commonData.getCommonCountries);
  var countries = (0, _react.useMemo)(function () {
    return availableCountryIds ? allCountries.filter(function (country) {
      return availableCountryIds.includes(country.id);
    }) : allCountries;
  }, [availableCountryIds, allCountries]);
  var selectedCountries = (0, _reactRedux.useSelector)((0, _react.useMemo)(function () {
    return (0, _commonData.makeGetCountriesByIds)(selectedCountriesIds);
  }, [selectedCountriesIds]));
  var handleChangeSelectedCountries = (0, _react.useCallback)(function (value) {
    var countryIds = value.map(function (item) {
      return item.id;
    });
    setSelectedCountriesIds(countryIds);
    onUpdate({
      countryIds
    });
  }, [onUpdate]);
  var handleChangeSearch = (0, _react.useCallback)(function (event) {
    setSearchValue(event.target.value);
    onUpdate({
      search: event.target.value
    });
  }, [onUpdate]);
  return /*#__PURE__*/_react.default.createElement(_material.Box, {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    py: 3
  }, /*#__PURE__*/_react.default.createElement(_ui.SearchField, {
    placeholder: "Search campaigns",
    value: searchValue,
    onChange: handleChangeSearch
  }), /*#__PURE__*/_react.default.createElement(_material.Box, {
    width: 250,
    ml: 1
  }, /*#__PURE__*/_react.default.createElement(_CountriesPicker.CountriesPicker, {
    label: "Country Filter",
    searchLabel: "Search countries",
    name: "countryId",
    value: selectedCountries,
    multiple: true,
    onChange: handleChangeSelectedCountries,
    options: countries,
    classes: {
      valueLabel: classes.countryValueLabel,
      buttonWrapper: classes.countryButtonWrapper,
      popper: classes.popper
    },
    buttonIconProps: {
      fontSize: 0.8
    }
  })));
};

var _default = /*#__PURE__*/(0, _react.memo)(CampaignsFilter);

exports.default = _default;